var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SubTitle',{attrs:{"text":"Mapa de sectores"}}),_c('div',{staticClass:"card-section"},[_c('HeatMap',{attrs:{"points":_vm.points}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }